import { Link, useParams } from "react-router-dom";
import { DATA, IBlog } from "./data";
import { DSTRUCTURE } from "./ds"

export enum Blogtype {
  DS, // 0 data structure
  // ALGO, 1 algorithm not implemented yet.
  ALL, // 2 for all blog TypeScript, Kotlin, Jetpack Compose ...

}

interface Props {
  BlogType: Blogtype
}
const Blog = ({ BlogType }: Props) => {
  const { blogid } = useParams();

  let blog: IBlog | undefined;
  if (BlogType === Blogtype.ALL) {
    blog = DATA.data.find((blog) => blog.ID === Number(blogid));
  } else if (BlogType === Blogtype.DS) {
    blog = DSTRUCTURE.data.find((blog) => blog.ID === Number(blogid));
  }

  if (!blog) {
    return <h1>Not blog</h1>;
  }

  return (
    <body className="main_container">
      <header className="header">
        <nav className="header__menu">
          <Link className="header__menu__link" to="/">
            Home
          </Link>
          <Link className="header__menu__link" to="/projects">
            Projects
          </Link>
          <Link className="header__menu__link" to="/blogs">
            Blogs
          </Link>
          <div className="dropdown">
            <Link className="header__menu__link" to="" data-bs-toggle="dropdown" aria-expanded="false">
              Explore
            </Link>
            <ul className="dropdown-menu">
              <Link className="dropdown-item" to="/ds">
                Data Structure
              </Link>
            </ul>
          </div>
        </nav>
      </header>
      <main className="presentation">
        <section className="presentation__content--blog">
          <h1 className="presentation__content__title">{blog.Title}</h1>
          {blog.Content.map((content, idex) => {
            return (
              <div className="" key={idex}>
                <h2 className="presentation__content__subtitle">
                  {content.Title}
                </h2>
                <p className="presentation__content__text">{content.Text}</p>
                {content.Sample && <pre className="code">{content.Sample}</pre>}
              </div>
            );
          })}
          <a className="social_link" href={blog.SocialLink}>
            <h1 className="author__highlighted"> By {blog.Author}</h1>
          </a>
          {
            blog.SourceCodeLinkName &&
            <a className="social_link" href={blog.SourceCodeLink}>
              <h1 className="source__code-highlighted"> Source code: {blog.SourceCodeLinkName}</h1>
            </a>
          }
          <h1 className="presentation__content__title">{blog && blog.Resource && blog.Resource.length > 0 && "Resources"} </h1>
          {
            blog && blog.Resource && blog.Resource.length > 0 && (
              <>
                {blog.Resource.map((resource, idx) => (
                  <div key={idx}>
                    <a className="social_link" href={resource.ResourceLink}>
                      <span className="source__code-highlighted">{resource.ResourceLinkName}</span>
                    </a>
                    <br />
                  </div>
                ))}
              </>
            )
          }
          <h1 className="presentation__content__title">Follow Me</h1>
          {
            blog && blog.SocialNetwork && blog.SocialNetwork.length > 0 && (
              <>
                {blog.SocialNetwork.map((social, idx) => (
                  <div key={idx} style={{ display: "inline-block" }}>
                    <a className="social_link" href={social.Link}>
                      <img
                        style={{ marginRight: "20px", width: "50px", height: "50px" }}
                        src={social.Image}
                        alt={"social"}
                      />
                    </a>
                    <br />
                  </div>
                ))}
              </>
            )
          }
        </section>
      </main>
      <footer className="footer">
        <p>Made by BinaryStack Labs &copy; 2025</p>
      </footer>
    </body>
  );
};

export default Blog;
